import {TAGS} from "../config/constants";

export const objectToQueryStrings = obj => `?${Object.keys(obj).filter(key => obj[key] !== undefined).map(key => `${key}=${encodeURIComponent(obj[key])}`).join('&')}`;

export const getProvidedTags = (result, type, isListItems = false) => result ?
    [...result.map((result) => ({type, id: isListItems ? parseInt(result.value) : result.id})), {
        type,
        id: TAGS.DEFAULT
    }] :
    [{type, id: TAGS.DEFAULT}];